<template>
    <div>
        <el-container>
            <el-main>
                接口访问日志
                <el-row :gutter="10" style="margin-top:10px; align: center;">
                    <el-col :span="4">
                        <el-input
                          placeholder="请输入搜索内容"
                          v-model="q"
                          clearable>
                        </el-input>
                    </el-col>
                    <el-col :span="2">
                        <el-button type="primary" icon="el-icon-search" @click="handleSearch()">搜索</el-button>
                    </el-col>
                </el-row>
                <el-table stripe :data="tableData" border style="width: 100%; margin-top:10px;"  size="mini">
                    <el-table-column align="center" prop="id" label="#" width="50">
                    </el-table-column>
                    <el-table-column align="center" prop="username" label="用户名" width="100">
                    </el-table-column>
                    <el-table-column align="center" prop="method" label="请求方法" width="100">
                    </el-table-column>
                    <el-table-column align="center" show-overflow-tooltip prop="uri" label="请求路径" width="110">
                    </el-table-column>
                    <el-table-column align="center" prop="remoteAddress" label="源IP" width="110">
                    </el-table-column>
                    <el-table-column align="center" prop="languageTag" label="语言">
                    </el-table-column>
                    <el-table-column align="center" show-overflow-tooltip prop="headers" label="请求头">
                    </el-table-column>
                    <el-table-column align="center" prop="status" label="响应码">
                    </el-table-column>
                    <el-table-column align="center" prop="localCreateTime" label="请求时间">
                    </el-table-column>
                </el-table>
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 40, 60, 80, 100]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </el-main>
        </el-container>
    </div>
</template>
<style>
</style>
<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'

export default {
    name: 'httptrace',
    data() {
        return {
            q: '',
            deleteDialogVisible: false,
            currentOperaRow: null,
            currentPage: 1,
            total: 0,
            limit: 20,
            tableData: []
        }
    },
    methods: {
        handleSizeChange(val) {
            this.limit = val
            this.getHttpTraceLogs()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getHttpTraceLogs()
        },
        getHttpTraceLogs() {
            let params = {
                page: this.currentPage,
                limit: this.limit
            }
            if (this.q) {
                params['q'] = this.q
            }

            this.$api.api.getHttpTraceLogs(params).then(
                resp => {
                    this.tableData = resp.data
                    this.currentPage = resp.page.page
                    this.total = resp.page.total
                })
        },
        handleSearch() {
            this.getHttpTraceLogs()
        }
    },
    mounted() {
        this.getHttpTraceLogs()
    },
    computed: {
        ...mapGetters([
          'hasPerm'
        ])
    },
    components: {}
}
</script>


// WEBPACK FOOTER //
// src/views/admin/log/httptrace.vue